<template>
  <v-footer height="auto">
    <v-card flat tile class="text-xs-center full-width pt-3">
      <v-avatar :tile="true" :size="80" color="grey lighten-4">
        <img src="@/assets/img/aaron-farr-circle.png" alt="Aaron Farr">
      </v-avatar>
      <v-card-text class="pb-0">
        <div class="headline font-weight-light">I believe in maximizing liberty with technology;</div>
      </v-card-text>
      <v-card-text class="pt-2">
        <div class="subheading font-weight-regular">
          by exploring ways of applying the latest tech to optimize life.<br>
          When I make something that works; I share it with you.<br>
        </div>
      </v-card-text>
      <!-- <v-card-text class="pt-2">
        <div class="subheading font-weight-regular font-italic">
          I use Google products whenever possible.
        </div>
      </v-card-text> -->
      <!-- <v-card-text class="pt-0">
        <form ref="hire" action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
          <input type="hidden" name="cmd" value="_s-xclick">
          <input type="hidden" name="hosted_button_id" value="Y62455AZ2DX62">
          <v-btn @click="hire()" color="success">Hire me for a day</v-btn>
        </form>
      </v-card-text> -->
      <v-divider></v-divider>
      <v-card-text class="lighten-2--text">
        &copy;2019 Copyright <strong>Aaron Farr</strong>
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
    }
  },
  methods: {
    hire() {
      this.$refs.hire.submit()
    }
  }
}
</script>

<style>
  .full-width {
    width: 100%;
  }
</style>
